import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

import { routeMap } from "../routes/portalRoutes";
import KickClient from "../utils/portalClient";

import { URL_KICK_WEBSITE_PATIENT_PORTAL } from "~/shared/sharedConstants";

export default function PortalBillingStripe() {
  let location = useLocation();

  useEffect(() => {
    redirectToStripeBilling();
  });

  const redirectToStripeBilling = () => {
    // prevent circular redirects
    let returnURL =
      location.pathname == routeMap.paymentPortal
        ? URL_KICK_WEBSITE_PATIENT_PORTAL
        : window.location.href;

    KickClient.newAuthenticatedClient()
      .post("/billing-url", { currentURL: returnURL })
      .then(function (response) {
        // console.log(response);
        window.location.assign(response.data.BillingURL);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  return null;
}
